import React from 'react';
import { Button, Label, Menu, Popup } from 'semantic-ui-react';

const styleMenu: React.CSSProperties = { backgroundColor: '#f0f0ff' };
const styleMenuItem: React.CSSProperties = { paddingLeft: '5px' };

export const MenuDeListado = (props: {
    cantidadDeAlumno: number;
    alPresionarCorreos: () => void;
}) => {
    return (
        <Menu borderless size='small' style={styleMenu} attached='top'>
            <Menu.Item fitted style={styleMenuItem}>
                <Popup
                    inverted
                    trigger={
                        <Button
                            basic
                            color='black'
                            icon='mail outline'
                            onClick={() => props.alPresionarCorreos()}
                        />
                    }
                    content='Mostrar correos'
                />

                <Label basic color='black' pointing='left'>
                    Copiar correos
                </Label>
            </Menu.Item>

            <Menu.Item position='right' style={styleMenuItem}>
                <b>{props.cantidadDeAlumno} alumnos en total</b>
            </Menu.Item>
        </Menu>
    );
};



// WEBPACK FOOTER //
// ./src/modulos/Horarios/DetalleDelCurso/Informacion/MenuDeListado.tsx